import React from "react";

const StorageCount = ({
  activeTab,
  setActiveTab,
  driversStorage,
  vehicleStorage,
  setActiveVehicle,
}) => {
  return (
    <table className="table align-items-center table-vhcls count-table relative">
      <thead>
        <tr>
          <th
            data-tip="All Vehicles"
            onClick={() => setActiveTab(0)}
            style={{ fontWeight: "normal" }}
            className={`text-center pointer text-xxs allActivebtn p-0 top-left-radius ${
              activeTab == 0 ? "activeTab allActivebtnDark" : null
            }`}
          >
            Drivers
            <div>
              <b className="font-13">
                {(driversStorage / 1048576).toFixed(2)} GB
              </b>
            </div>
          </th>
          <th
            data-tip="Active Vehicles"
            onClick={() => {
              setActiveTab(1);
              setActiveVehicle(null);
            }}
            style={{ fontWeight: "normal" }}
            className={`text-center pointer text-xxs movingButton p-0 top-right-radius ${
              activeTab == 1 ? "activeTab movingButtonDark" : null
            }`}
          >
            Vehicles
            <div>
              <b className="font-13">
                {(vehicleStorage / 1048576).toFixed(2)} GB
              </b>
            </div>
          </th>
        </tr>
      </thead>
    </table>
  );
};

export default React.memo(StorageCount);
